import { IDefaultService } from "../default-service/default-service.interface";

export interface ICategoryService {
  id: number;
  title: string;
  description: string;
  iconImage: string | null;
  isRecall: boolean;
  isMaintenance: boolean;
  hasRecall: boolean;
  recallWarning: string;
  availableServices: IDefaultService[];
}

interface Image {
  imageName: string;
  imageType: string | null;
  file: string | null;
}

export interface ICategoryResponse {
  id: number;
  country: string;
  division: number;
  priority: number;
  active: boolean;
  name: string;
  createUser: string;
  pickupDelivery: boolean;
  mobileService: boolean;
  image: Image | null;
  revision: boolean;
  recall: boolean;
  osrName: string;
  availableServices: IDefaultService[];
}
